<h2 *ngIf="sections.length > 0" class="mt-3">Details</h2>
<div *ngIf="sections.length > 0" class="rbrd mb-30 errorEnhance">
  <div *ngFor="let section of sections">
    <div>
      <p [innerHTML]="section.body | mdToHtml"></p>
      <app-revision-notices-note-section *ngIf="section.noteSections" [noteSections]="section.noteSections"></app-revision-notices-note-section>
      <div *ngIf="(section?.xmlDataArray)!.length > 0">
        <app-prism-xml *ngFor="let xmlData of section.xmlDataArray" [xmlData]="xmlData"></app-prism-xml>
      </div>
      <div [innerHtml]="section.subBody! | mdToHtml"></div>
      <div *ngIf="section.tableSections">
        <app-table-section [tableSections]="section.tableSections" [isRevisionNoticesPage]="true"></app-table-section>
      </div>
    </div>
  </div>
</div>
